import React from 'react';
import { colourString } from '../../../library';
export function XIcon(_a) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b, _c = _a.tone, tone = _c === void 0 ? 'accent-3' : _c;
    return (React.createElement("svg", { className: "kplr_xIcon", width: size, height: size, viewBox: "0 0 21 22", fill: "none" },
        React.createElement("path", { style: { transform: 'rotate(45deg)', transformOrigin: 'center center' }, fill: colourString(tone), d: "M11.3137 0.676239H9.33381V10.01H0V11.9899H9.33381V21.3238H11.3137V11.9899H20.6475V10.01H11.3137V0.676239Z" })));
}
export default XIcon;
